<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Informations
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-edit-password"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement de mot de passe
              </router-link>
            </li>

            <!-- <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement RIB
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement Téléphone
              </router-link>
            </li> -->

            <!-- <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Ville Retour & Ramassage
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-12">
                <div class="form-group mb-4 position-relative">
                  <label class="fw-semibold mb-10">Mot de passe actuel</label>

                  <input
                    :type="showCurrent ? 'text' : 'password'"
                    class="form-control"
                    v-model="userData.currentPassword"
                    placeholder="Mot de passe actuel"
                  />

                  <i
                    class="ph"
                    :class="showCurrent ? 'ph-eye-slash' : 'ph-eye'"
                    @click="showCurrent = !showCurrent"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 42px;
                      cursor: pointer;
                    "
                  ></i>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-4 position-relative">
                  <label class="fw-semibold mb-10">Nouveau mot de passe</label>

                  <input
                    :type="showNew ? 'text' : 'password'"
                    class="form-control"
                    v-model="userData.newPassword"
                    placeholder="Nouveau mot de passe"
                  />

                  <i
                    class="ph"
                    :class="showNew ? 'ph-eye-slash' : 'ph-eye'"
                    @click="showNew = !showNew"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 42px;
                      cursor: pointer;
                    "
                  ></i>

                  <small
                    v-if="userData.newPassword && !isPasswordValid"
                    class="text-danger"
                  >
                    Le mot de passe doit contenir au moins 8 caractères, un
                    chiffre et un caractère spécial.
                  </small>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-4 position-relative">
                  <label class="fw-semibold mb-10"
                    >Confirmer le mot de passe</label
                  >

                  <input
                    :type="showConfirm ? 'text' : 'password'"
                    class="form-control"
                    v-model="userData.confirmNewPassword"
                    placeholder="Confirmation"
                  />

                  <i
                    class="ph"
                    :class="showConfirm ? 'ph-eye-slash' : 'ph-eye'"
                    @click="showConfirm = !showConfirm"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 42px;
                      cursor: pointer;
                    "
                  ></i>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                    :disabled="
                      !userData.currentPassword ||
                      !userData.newPassword ||
                      !userData.confirmNewPassword
                    "
                  >
                    Enregistrer les modifications
                  </button>
                  <!-- <button
                    type="button"
                    class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                  >
                    <i
                      class="flaticon-delete lh-1 me-1 position-relative top-2"
                    ></i>
                    <span class="position-relative">Cancel</span>
                  </button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "AccountSettings",

  setup() {
    const { showToast } = useAppToast();

    const userData = reactive<Record<string, any>>({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    const auth = useAuthStore();

    // 👁 Toggle visibility
    const showCurrent = ref(false);
    const showNew = ref(false);
    const showConfirm = ref(false);

    // 🔐 Password regex validation
    const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

    const isPasswordValid = computed(() =>
      passwordRegex.test(userData.newPassword)
    );

    const isFormValid = computed(
      () =>
        userData.currentPassword &&
        userData.newPassword &&
        userData.confirmNewPassword &&
        isPasswordValid.value &&
        userData.newPassword === userData.confirmNewPassword
    );
    async function logout() {
      try {
        // 🔐 Inform backend (optional but recommended)
        await api.post(`/api/auth/client/user_logout`);
      } catch (error) {
        console.warn("Logout API failed, continuing client logout", error);
      } finally {
        auth.clearAuth();

        // Optional: redirect to login
        window.location.href = "/login";
      }
    }
    async function submitForm() {
      if (!isPasswordValid.value) {
        showToast(
          "Le mot de passe doit contenir au moins 8 caractères, un chiffre et un caractère spécial.",
          "error"
        );
        return;
      }

      if (userData.newPassword !== userData.confirmNewPassword) {
        showToast(
          "Le nouveau mot de passe et la confirmation ne correspondent pas.",
          "error"
        );
        return;
      }

      try {
        const formData = new FormData();
        formData.append("old_pwd", userData.currentPassword);
        formData.append("password", userData.newPassword);
        formData.append("c_password", userData.confirmNewPassword);

        const response = await api.post(
          `/api/auth/client/EditPassword`,
          formData
        );

        if (response.data.success) {
          showToast("Mot de passe mis à jour avec succès ✅", "success");
          userData.currentPassword = "";
          userData.newPassword = "";
          userData.confirmNewPassword = "";
          logout();
        } else {
          showToast(response.data.message, "error");
        }
      } catch (e) {
        showToast("Erreur lors de la mise à jour du mot de passe.", "error");
      }
    }

    return {
      userData,
      submitForm,
      showCurrent,
      showNew,
      showConfirm,
      isPasswordValid,
      isFormValid,
    };
  },
});
</script>